import { CaretLeft, CaretRightIcon as CaretRight } from '@phosphor-icons/react';
import React, { FunctionComponent, RefObject } from 'react';

import { BACKWARD, FORWARD } from '../../constants/navigationConstants';

interface ScrollButtonsProps {
  className: string;
  moveTo: (direction: string) => void;
  forwardedRef: RefObject<HTMLLIElement>;
  show: boolean;
  classBuilder: (...args: any[]) => string;
  disabledForward: boolean;
  disabledBackward: boolean;
}

const ScrollButtons: FunctionComponent<ScrollButtonsProps> = ({
  className,
  moveTo,
  forwardedRef,
  show,
  classBuilder,
  disabledForward,
  disabledBackward,
}) => {
  const c = classBuilder;

  if (!show) {
    return <></>;
  }

  return (
    <li className={className} role="presentation" ref={forwardedRef}>
      <button
        className={c('__scroll_buttons', '__scroll_buttons--active')}
        aria-hidden="true"
        tabIndex={-1}
        aria-label="Scroll left"
        onClick={() => moveTo(BACKWARD)}
        disabled={disabledBackward}
      >
        <CaretLeft size={24} weight="fill" />
      </button>
      <button
        className={c('__scroll_buttons', '__scroll_buttons--active')}
        aria-hidden="true"
        tabIndex={-1}
        aria-label="Scroll right"
        onClick={() => moveTo(FORWARD)}
        disabled={disabledForward}
      >
        <CaretRight size={24} weight="fill" />
      </button>
    </li>
  );
};

export default ScrollButtons;
